<template>
  <div class="bg-light-gray border-radius--light text-center col-12">
    <button
      class="btn bg-light-white pt-1 mb-3 mt-3 col-12 col-md-6 col-lg-6"
      v-on="$listeners"
    >
      <div>
        <i class="fas fa-file-plus pr-2 text-green" />
        <span v-text="text" />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ActivationButton',
  props: { text: { type: String, default: '' } },
};
</script>
